// LOW-LEVEL Inicializace jednotlivých boxů

import { CNCRecombee } from '@customTypes/recombee/CNCRecombee';

export const initBoxes = () => {
  const boxConfigurations: NodeListOf<HTMLTemplateElement> = document.querySelectorAll(
    '[data-recombee-box-json]'
  );

  if (!window.CNC.recombee) return;

  window.CNC.recombee.box = window.CNC.recombee.box || [];

  if (boxConfigurations.length)
    boxConfigurations.forEach((configuration) => {
      const { recombeeBoxJson } = configuration.dataset;

      const recombeeBoxConfig: CNCRecombee.Box = JSON.parse(
        recombeeBoxJson as string
      ) as CNCRecombee.Box;

      recombeeBoxConfig.adHTMLcode = atob(recombeeBoxConfig.adHTMLcode);

      if (recombeeBoxConfig && window.CNC.recombee) {
        if (window.CNC.recombee.box) window.CNC.recombee.box.push(recombeeBoxConfig);
      }
    });
};
